import { render, staticRenderFns } from "./NewDocumentsBadge.vue?vue&type=template&id=e68cf400&"
import script from "./NewDocumentsBadge.vue?vue&type=script&lang=js&"
export * from "./NewDocumentsBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports